import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { useAPI } from '../api';
import { closeLoading, openLoading } from '../loading';

const useProvideAuth = () => {
  const history = useHistory();
  const api = useAPI();

  const [user, setUser] = useState();

  const resetUser = () => {
    setUser();
  };

  const signin = (
    { redirectPath, sessionToken, memberID, accountCode, isAdmin } = {
      redirectPath: '',
      sessionToken: '',
      memberID: null,
      accountCode: '',
      isAdmin: false,
    }
  ) => {
    openLoading();
    setUser({
      sessionToken,
      memberID: isAdmin ? -1 : memberID,
      accountCode,
      isAdmin,
    });
    setTimeout(() => {
      if (redirectPath) {
        closeLoading();
        history.replace(redirectPath);
      } else {
        closeLoading();
      }
    }, 1000);
  };

  const signout = ({ resetLocalStorage } = { resetLocalStorage: false }) => {
    if (resetLocalStorage) {
      localStorage.removeItem('ac');
    }
    sessionStorage.removeItem('st');
    sessionStorage.removeItem('mi');
    sessionStorage.removeItem('ac');
    sessionStorage.removeItem('ia');
    resetUser();
  };

  useEffect(() => {
    if (!user || !user.sessionToken) return;
    api.updateToken(user.sessionToken || '');
  }, [user, api]);

  return {
    user,
    signin,
    signout,
  };
};

export default useProvideAuth;
